export { default as capitalize } from './capitalize';
export { default as staticlink } from './staticlink';
export { default as capitalizeAll } from './capitalizeAll';
export { default as upperCase } from './upperCase';
export { default as emptyToDash } from './emptyToDash';
export { default as spacesToDash } from './spacesToDash';
export { default as shorten } from './shorten';
export * from './numbers';
export * from './dateTime';
export * from './genericStringFormatters';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/modules/shared/filters/index.ts